import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import CompanyPublicMembers from 'src/components/CompanyPublicMembers/CompanyPublicMembers.vue';

const {
  publicMembers,
  publicMembersTotal,
  companyAlias,
} = getSsrState();

createVueApp({
  el: '[data-company-public-members]',
  render(h) {
    return h(
      CompanyPublicMembers,
      {
        props: {
          publicMembers,
          publicMembersTotal,
          companyAlias,
        },
      },
    )
  },
});
